var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ongkir"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col items-start gap-6"
  }, [_c('div', {
    staticClass: "bg-white p-6 w-4/12 mdmax:w-full shadow-md"
  }, [_c('p', {
    staticClass: "text-lg font-bold mb-6"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.title')))]), _c('div', {
    staticClass: "mb-6 text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.origin')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": _vm.$t('ongkir.originPlaceholder')
    },
    on: {
      "input": function input($event) {
        return _vm.searchCity($event, 'origin');
      }
    },
    model: {
      value: _vm.originSearch,
      callback: function callback($$v) {
        _vm.originSearch = $$v;
      },
      expression: "originSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching['origin'] ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion['origin'] ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300 ",
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'origin');
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('ongkir.dataNotFound')) + " ")])]) : _vm._e()])], 1)]), _c('div', {
    staticClass: "mb-6 text-left relative"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.destination')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "withIcon": "",
      "type": "text",
      "placeholder": _vm.$t('ongkir.destinationPlaceholder')
    },
    on: {
      "input": function input($event) {
        return _vm.searchCity($event, 'destination');
      }
    },
    model: {
      value: _vm.destinationSearch,
      callback: function callback($$v) {
        _vm.destinationSearch = $$v;
      },
      expression: "destinationSearch"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1), _vm.isSearching['destination'] ? _c('img', {
    staticClass: "w-8 absolute top-1/2 transform -translate-y-1/2 right-2",
    attrs: {
      "src": require("@/assets/images/rolling.gif")
    }
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.visibleSuggestion['destination'] ? _c('div', {
    staticClass: "mt-1 z-10 border rounded-lg absolute top-full left-0 w-full bg-white"
  }, [_vm.cities ? _c('ul', {
    staticClass: "max-h-40 overflow-y-scroll"
  }, _vm._l(_vm.cities, function (city, index) {
    return _c('li', {
      key: 'city-' + index,
      staticClass: "cursor-pointer px-3 py-2 hover:bg-neutral-300 ",
      on: {
        "click": function click($event) {
          return _vm.selectCity(city, 'destination');
        }
      }
    }, [_vm._v(" " + _vm._s(city.village) + ", " + _vm._s(city.area_display) + " ")]);
  }), 0) : _c('div', {
    staticClass: "py-4 text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t('ongkir.dataNotFound')) + " ")])]) : _vm._e()])], 1)]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.weight')))]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "number",
      "withIcon": "",
      "placeholder": _vm.$t('ongkir.weightPlaceholder')
    },
    model: {
      value: _vm.payloads.package_weight,
      callback: function callback($$v) {
        _vm.$set(_vm.payloads, "package_weight", $$v);
      },
      expression: "payloads.package_weight"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Box')], 1), _c('div', {
    staticClass: "absolute right-3 top-1/2 transform -translate-y-1/2"
  }, [_vm._v(" Kg ")])], 1)]), _c('div', {
    staticClass: "mb-10"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-4 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.logistic')))]), _c('div', {
    staticClass: "grid-layout"
  }, [_c('div', {
    staticClass: "mb-2 col-span-2 flex items-center"
  }, [_c('input', {
    staticClass: "styled-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "select-all-logistics"
    },
    domProps: {
      "checked": _vm.selectedLogistics.length === _vm.logisticProvider.length
    },
    on: {
      "change": function change($event) {
        _vm.selectedLogistics = $event.target.checked ? _vm.logisticProvider.map(function (l) {
          return l.id;
        }) : [];
      }
    }
  }), _c('label', {
    staticClass: "text-sm font-semibold",
    attrs: {
      "for": "select-all-logistics"
    }
  }, [_vm._v(_vm._s(_vm.$t('ongkir.allLogistic')))])]), _vm._l(_vm.logisticProvider, function (logistic, index) {
    return _c('div', {
      key: 'logistic-' + index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedLogistics,
        expression: "selectedLogistics"
      }],
      staticClass: "styled-checkbox",
      attrs: {
        "type": "checkbox",
        "name": "logistics",
        "id": logistic.id
      },
      domProps: {
        "value": logistic.id,
        "checked": Array.isArray(_vm.selectedLogistics) ? _vm._i(_vm.selectedLogistics, logistic.id) > -1 : _vm.selectedLogistics
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.selectedLogistics,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = logistic.id,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && (_vm.selectedLogistics = $$a.concat([$$v]));
            } else {
              $$i > -1 && (_vm.selectedLogistics = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.selectedLogistics = $$c;
          }
        }
      }
    }), _c('label', {
      staticClass: "text-sm",
      attrs: {
        "for": logistic.id
      }
    }, [_vm._v(_vm._s(logistic.name))])]);
  })], 2)]), _c('div', {
    staticClass: "flex justify-end items-center"
  }, [_c('Button', {
    attrs: {
      "buttonText": _vm.$t('ongkir.submit'),
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "action": function action($event) {
        return _vm.cekOngkir();
      }
    }
  })], 1)]), _c('div', {
    staticClass: "w-8/12 mdmax:w-full ongkir-list flex items-stretch shadow-md"
  }, [_vm.ongkirList.length < 1 ? [_c('div', {
    staticClass: "flex-1 flex justify-center flex-col items-center bg-white py-12 px-6"
  }, [_c('div', {
    staticClass: "flex justify-center items-center flex-col h-full text-center"
  }, [_c('p', {
    staticClass: "font-bold mb-1"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.invalidTitle')))]), _c('p', {
    staticClass: "text-sm text-neutral-500"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.invalidDesc')))])])])] : [_c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    staticClass: "py-3 px-6 flex mdmax:flex-col justify-between mdmax:justify-start gap-9 mdmax:gap-4 items-center mdmax:items-start bg-white shadow-border-b mdmax:px-4"
  }, [_c('div', {
    staticClass: "flex items-center gap-6"
  }, [_c('Box2', {
    attrs: {
      "color": "primary-500"
    }
  }), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('p', {
    staticClass: "text-xs"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.show')) + " " + _vm._s(_vm.totalServiceCount) + " " + _vm._s(_vm.$t('ongkir.service')))]), _c('p', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.originInformation.district) + " - " + _vm._s(_vm.destinationInformation.district))])])], 1), _c('div', {
    staticClass: "flex gap-2 items-center"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/Custom.svg")
    }
  }), _c('p', {
    staticClass: "text-xs text-white bg-primary-500 rounded-md px-2 py-1"
  }, [_vm._v(_vm._s(_vm.payloads.package_weight) + " kg")])])]), _c('div', {
    staticClass: "px-6 mdmax:px-4 pt-6 pb-6"
  }, _vm._l(_vm.deliveryServiceByGroup, function (value, key, index) {
    return _c('div', {
      key: index,
      staticClass: "border border-gray-200 bg-white rounded-xl shadow-sm mb-4 overflow-hidden"
    }, [_c('input', {
      staticClass: "hidden",
      attrs: {
        "type": "checkbox",
        "id": key
      },
      domProps: {
        "checked": value.isVisible
      }
    }), _c('label', {
      staticClass: "flex justify-between items-center p-4 cursor-pointer hover:bg-neutral-50 transition-colors",
      class: {
        'border-b border-gray-200': value.isVisible
      },
      attrs: {
        "for": key
      },
      on: {
        "click": function click($event) {
          return _vm.expand(key, value.isVisible);
        }
      }
    }, [_c('p', {
      staticClass: "text-base font-bold text-neutral-800"
    }, [_vm._v(_vm._s(key))]), _c('span', {
      staticClass: "transition-transform duration-300 text-neutral-500",
      class: {
        'transform rotate-180': value.isVisible
      }
    }, [_c('Chevron', {
      attrs: {
        "direction": "down"
      }
    })], 1)]), _c('div', {
      staticClass: "sub bg-neutral-50",
      class: {
        open: value.isVisible
      }
    }, [_c('div', {
      staticClass: "p-4"
    }, _vm._l(value.package, function (service, idx) {
      return _c('div', {
        key: 'service' + idx,
        staticClass: "shadow-sm px-4 py-3 rounded-lg mb-3 last:mb-0 flex justify-between items-center transition-all duration-200 border cursor-pointer",
        class: {
          'bg-secondary-100 opacity-60 cursor-not-allowed border-neutral-200': parseInt(service.package.final_cost) <= 0 || parseInt(_vm.payloads.package_weight) < parseInt(service.package.minimum_weight) || parseInt(_vm.payloads.package_weight) > parseInt(service.package.maximum_weight),
          'bg-white border-transparent hover:border-secondary-300': parseInt(service.package.final_cost) > 0 && parseInt(_vm.payloads.package_weight) >= parseInt(service.package.minimum_weight) && parseInt(_vm.payloads.package_weight) <= parseInt(service.package.maximum_weight)
        },
        on: {
          "click": function click($event) {
            return _vm.selectService(service);
          }
        }
      }, [_c('div', {
        staticClass: "flex gap-4 items-center"
      }, [_c('div', {
        staticClass: "w-16 flex items-center justify-center"
      }, [service.logo ? _c('img', {
        staticClass: "max-h-8 object-contain",
        attrs: {
          "src": service.logo,
          "alt": service.name
        }
      }) : _c('LogisticPlaceholder', {
        attrs: {
          "logisticName": service.name
        }
      })], 1), _c('div', {
        staticClass: "flex flex-col gap-1"
      }, [_c('p', {
        staticClass: "font-medium text-xs"
      }, [_vm._v(_vm._s(service.name))]), _c('p', {
        staticClass: "text-sm font-semibold text-neutral-800"
      }, [_vm._v(_vm._s(service.package.name))]), parseInt(_vm.payloads.package_weight) < parseInt(service.package.minimum_weight) ? [_c('p', {
        staticClass: "text-xs text-red-500 mt-0.5"
      }, [_vm._v("Minimal berat pengiriman " + _vm._s(service.name) + " " + _vm._s(service.package.minimum_weight) + " Kg")])] : parseInt(_vm.payloads.package_weight) > parseInt(service.package.maximum_weight) ? [_c('p', {
        staticClass: "text-xs text-red-500 mt-0.5"
      }, [_vm._v("Maksimal berat pengiriman " + _vm._s(service.name) + " " + _vm._s(service.package.maximum_weight) + " Kg")])] : parseInt(service.package.final_cost) <= 0 ? [_c('p', {
        staticClass: "text-xs text-red-500 mt-0.5"
      }, [_vm._v("Layanan saat ini tidak tersedia")])] : _vm._e()], 2)]), parseInt(service.package.final_cost) > 0 && parseInt(_vm.payloads.package_weight) >= parseInt(service.package.minimum_weight) && parseInt(_vm.payloads.package_weight) <= parseInt(service.package.maximum_weight) ? _c('div', {
        staticClass: "flex flex-col gap-1 text-right items-end"
      }, [_c('p', {
        staticClass: "flex items-center gap-2"
      }, [_c('Time', {
        attrs: {
          "width": "12",
          "height": "12"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text-xs text-secondary-600 font-medium"
      }, [_vm._v(_vm._s(service.package.est_delivery_time_range_min) + " - " + _vm._s(service.package.est_delivery_time_range_max))])], 1), service.package.final_cost !== service.package.shipment_cost ? _c('p', {
        staticClass: "text-xs text-neutral-400 line-through"
      }, [_vm._v(_vm._s(_vm._f("currencyFormat")(service.package.shipment_cost)))]) : _vm._e(), _c('p', {
        staticClass: "text-base font-bold text-primary-600"
      }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(service.package.final_cost)) + " ")])]) : _vm._e()]);
    }), 0)])]);
  }), 0)])]], 2)]), _c('Modal', {
    attrs: {
      "modalVisible": _vm.showConfirmationModal,
      "id": "confirmation-modal",
      "width": "400px"
    },
    on: {
      "close": function close($event) {
        _vm.showConfirmationModal = false;
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex flex-col items-center text-center py-4"
  }, [_c('p', {
    staticClass: "font-bold text-xl text-neutral-800 mb-3"
  }, [_vm._v("Konfirmasi Pengiriman")]), _c('p', {
    staticClass: "text-sm text-neutral-600 mb-8 px-2"
  }, [_vm._v("Lanjutkan pengiriman paket ? Anda akan dialihkan ke halaman Kirim Paket untuk melengkapi data dan menyelesaikan proses pengiriman.")]), _c('div', {
    staticClass: "flex gap-4 w-full"
  }, [_c('Button', {
    staticClass: "flex-1",
    attrs: {
      "buttonText": "Batal",
      "type": "secondary"
    },
    on: {
      "action": function action($event) {
        _vm.showConfirmationModal = false;
      }
    }
  }), _c('Button', {
    staticClass: "flex-1",
    attrs: {
      "buttonText": "Lanjutkan",
      "type": "primary"
    },
    on: {
      "action": _vm.proceedToCreateOrder
    }
  })], 1)])])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }